export default "__VITE_ASSET__bF3_KA2n__"